import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Platform from "./pages/Platform";
import Cybersecurity from "./pages/Cybersecurity";
import BudgetScanner from "./pages/BudgetScanner";
import InfrastructureRisk from "./pages/InfrastructureRisk";
import Demo from "./pages/Demo";
import CaseStudies from "./pages/CaseStudies";
import Pricing from "./pages/Pricing";
import DataCenterWater from "./pages/DataCenterWater";
import SolutionsDataCenterWater from "./pages/SolutionsDataCenterWater";
import GovernmentEight from "./pages/GovernmentEight";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import BrandStyleGuide from "./pages/BrandStyleGuide";
import Certification from "./pages/Certification";
import VideoDemo from "./pages/VideoDemo";
import PortalLogin from "./pages/PortalLogin";
import PortalDashboard from "./pages/PortalDashboard";
import PortalReports from "./pages/PortalReports";
import AuditIQReports from "./pages/AuditIQReports";
import AdminReports from "./pages/AdminReports";
import PortalUploads from "./pages/PortalUploads";
import AuditUpload from "./pages/AuditUpload";
import AuditHistory from "./pages/AuditHistory";
import AuditDashboard from "./pages/AuditDashboard";
import TrafficRecommendations from "./pages/TrafficRecommendations";
import AuditCrawler from "./pages/AuditCrawler";
import PublicScorecard from "./pages/PublicScorecard";
import PortalUsers from "./pages/PortalUsers";
import PortalCertification from "./pages/PortalCertification";
import PortalCurriculumLearner from "./pages/PortalCurriculumLearner";
import PortalAuditLogs from "./pages/PortalAuditLogs";
import PortalTickets from "./pages/PortalTickets";
import PortalAdminHub from "./pages/PortalAdminHub";
import DemoPreview from "./pages/DemoPreview";
import FreeMarketingAudit from "./pages/FreeMarketingAudit";
import PortalOnboarding from "./pages/PortalOnboarding";
import CrownInstituteAcademy from "./pages/CrownInstituteAcademy";
import { StudentLogin, TeacherAideLogin, ParentLogin } from "./pages/CrownLogin";
import { StudentDashboard, TeacherAideDashboard, ParentDashboard } from "./pages/CrownDashboards";
import { Store, Sponsors, Donate } from "./pages/CrownExtras";
import { Curriculum, Frameworks, Certifications, ContinuingEducation } from "./pages/CrownAcademics";
import AcademyDetail from "./pages/AcademyDetail";
import DemoCivicCrawler from "./pages/DemoCivicCrawler";
import {
  SportsLanding, SportPage, HealthIQPage, SportsCompliancePage, SportsDemoPage,
} from "./pages/sports/SportsPublic";
import { SportsDashboard } from "./pages/sports/SportsDashboards";
import SportsCommandCenter from "./pages/sports/SportsCommandCenter";
import {
  DemoIntelligenceDashboard, AthleteProfile, SportsDemoAdmin,
} from "./pages/sports/SportsDemoIntelligence";

// Iter 18 — Production Readiness Lock + SEO v2.0
import {
  TopDashboard, TopTeams, TopAthletes, TopCoaches,
  TopHealthIQ, TopCompliance, TopReports,
} from "./pages/sports/TopLevelSportsPages";
import { Privacy, Terms } from "./pages/legal/LegalPages";
import { NotFound404, Error500, Maintenance } from "./pages/system/SystemPages";
import { Security } from "./pages/system/Security";
import AdminSystem from "./pages/admin/AdminSystem";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { DemoModeBanner } from "./components/DemoModeBanner";

// Iter 19 — Enterprise Athletic Operations (14 modules)
import {
  MessagingCenter, SchedulingCenter, MedicalWorkflow,
  ComplianceCenterEnt, DocumentCenterEnt, AlertCenterEnt,
} from "./pages/enterprise/DeepModules";
import {
  EnterpriseHub, TrainingPerformanceScaffold, WearablesScaffold,
  PortalScaffold, ReportsScaffold, MobileOfflineScaffold,
  StaffWorkflowsScaffold, IntegrationsScaffold, AuditLogViewer,
} from "./pages/enterprise/ScaffoldModules";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <DemoModeBanner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/cybersecurity" element={<Cybersecurity />} />
            <Route path="/budget-scanner" element={<BudgetScanner />} />
            <Route path="/infrastructure" element={<InfrastructureRisk />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/data-center-water" element={<DataCenterWater />} />
            <Route path="/solutions/data-center-water" element={<SolutionsDataCenterWater />} />
            <Route path="/government-eight" element={<GovernmentEight />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/certification" element={<Certification />} />
            <Route path="/video-demo" element={<VideoDemo />} />
            <Route path="/brand" element={<BrandStyleGuide />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/system" element={<AdminSystem />} />
            <Route path="/portal/login" element={<PortalLogin />} />
            <Route path="/login" element={<Navigate to="/portal/login" replace />} />
            <Route path="/portal/admin/login" element={<Navigate to="/admin/login" replace />} />
            <Route path="/portal" element={<PortalDashboard />} />
            <Route path="/portal/analyze" element={<Navigate to="/auditiq/crawler" replace />} />
            <Route path="/portal/demo/:scenarioKey" element={<DemoPreview />} />
            <Route path="/free-audit" element={<FreeMarketingAudit />} />
            <Route path="/portal/onboarding" element={<PortalOnboarding />} />
            <Route path="/portal/reports" element={<PortalReports />} />
            <Route path="/portal/auditiq/reports" element={<AuditIQReports />} />
            <Route path="/portal/admin/reports" element={<AdminReports />} />
            <Route path="/portal/uploads" element={<PortalUploads />} />
            <Route path="/auditiq/upload" element={<AuditUpload />} />
            <Route path="/auditiq/history" element={<AuditHistory />} />
            <Route path="/auditiq/dashboard" element={<AuditDashboard />} />
            <Route path="/portal/traffic/recommendations" element={<TrafficRecommendations />} />
            <Route path="/auditiq/crawler" element={<AuditCrawler />} />
            <Route path="/scorecard/:token" element={<PublicScorecard />} />
            <Route path="/portal/users" element={<PortalUsers />} />
            <Route path="/portal/certification" element={<PortalCertification />} />
            <Route path="/portal/curriculum" element={<PortalCurriculumLearner />} />
            <Route path="/portal/audit-logs" element={<PortalAuditLogs />} />
            <Route path="/portal/tickets" element={<PortalTickets />} />
            <Route path="/portal/admin" element={<PortalAdminHub />} />

            {/* Crown Institute Academy */}
            <Route path="/crown-institute-academy" element={<CrownInstituteAcademy />} />
            <Route path="/student-login" element={<StudentLogin />} />
            <Route path="/teacher-aide-login" element={<TeacherAideLogin />} />
            <Route path="/parent-login" element={<ParentLogin />} />
            <Route path="/portal/student" element={<StudentDashboard />} />
            <Route path="/portal/teacher-aide" element={<TeacherAideDashboard />} />
            <Route path="/portal/parent" element={<ParentDashboard />} />
            <Route path="/store" element={<Store />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/curriculum" element={<Curriculum />} />
            <Route path="/frameworks" element={<Frameworks />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/continuing-education" element={<ContinuingEducation />} />

            {/* Dynamic academy detail (handles 14 slugs: 8 semesters + 6 special programs) */}
            <Route path="/academy/:slug" element={<AcademyDetail />} />

            {/* Civic Data AI Crawler Demos */}
            <Route path="/demo/civic-data-search" element={<DemoCivicCrawler />} />
            <Route path="/demo/budget-crawler" element={<DemoCivicCrawler />} />
            <Route path="/demo/public-records" element={<DemoCivicCrawler />} />

            {/* === Iter 18: top-level Sports routes (per spec §8 sitemap) === */}
            <Route path="/dashboard" element={<TopDashboard />} />
            <Route path="/teams" element={<TopTeams />} />
            <Route path="/athletes" element={<TopAthletes />} />
            <Route path="/coaches" element={<TopCoaches />} />
            <Route path="/health-iq" element={<TopHealthIQ />} />
            <Route path="/compliance" element={<TopCompliance />} />
            <Route path="/reports" element={<TopReports />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/security" element={<Security />} />

            {/* AuditIQ Sports + Health IQ vertical (preserved aliases) */}
            <Route path="/auditiq-sports" element={<SportsLanding />} />
            <Route path="/demo/sports" element={<DemoIntelligenceDashboard />} />
            <Route path="/athlete/:id" element={<AthleteProfile />} />
            <Route path="/admin/demo" element={<SportsDemoAdmin />} />
            <Route path="/auditiq-sports/healthiq" element={<HealthIQPage />} />
            <Route path="/auditiq-sports/compliance" element={<SportsCompliancePage />} />
            <Route path="/auditiq-sports/demo" element={<SportsDemoPage />} />
            <Route path="/auditiq-sports/command-center" element={<SportsCommandCenter />} />
            <Route path="/auditiq-sports/admin" element={<SportsDashboard />} />
            <Route path="/auditiq-sports/recruiting" element={<SportsDashboard />} />
            <Route path="/auditiq-sports/performance" element={<SportsDashboard />} />
            <Route path="/auditiq-sports/reports" element={<SportsDashboard />} />
            <Route path="/auditiq-sports/athlete-dashboard" element={<SportsDashboard />} />
            <Route path="/auditiq-sports/coach-dashboard" element={<SportsDashboard />} />
            <Route path="/auditiq-sports/athletic-director-dashboard" element={<SportsDashboard />} />
            <Route path="/auditiq-sports/dashboard/:role" element={<SportsDashboard />} />
            <Route path="/auditiq-sports/dashboard" element={<SportsDashboard />} />
            {/* Public sport pages (must come last so static routes above match first) */}
            <Route path="/auditiq-sports/:sport" element={<SportPage />} />

            {/* === Iter 18: branded system pages === */}
            <Route path="/500" element={<Error500 />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/404" element={<NotFound404 />} />

            {/* === Iter 19: Enterprise Athletic Operations (14 modules) === */}
            <Route path="/enterprise" element={<EnterpriseHub />} />
            <Route path="/enterprise/messaging" element={<MessagingCenter />} />
            <Route path="/enterprise/scheduling" element={<SchedulingCenter />} />
            <Route path="/enterprise/medical" element={<MedicalWorkflow />} />
            <Route path="/enterprise/compliance" element={<ComplianceCenterEnt />} />
            <Route path="/enterprise/documents" element={<DocumentCenterEnt />} />
            <Route path="/enterprise/alerts" element={<AlertCenterEnt />} />
            <Route path="/enterprise/performance" element={<TrainingPerformanceScaffold />} />
            <Route path="/enterprise/wearables" element={<WearablesScaffold />} />
            <Route path="/enterprise/portal" element={<PortalScaffold />} />
            <Route path="/enterprise/reports" element={<ReportsScaffold />} />
            <Route path="/enterprise/workflows" element={<StaffWorkflowsScaffold />} />
            <Route path="/enterprise/integrations" element={<IntegrationsScaffold />} />
            <Route path="/enterprise/audit" element={<AuditLogViewer />} />
            <Route path="/enterprise/mobile" element={<MobileOfflineScaffold />} />
            <Route path="/admin/audit" element={<AuditLogViewer />} />

            {/* Catch-all 404 */}
            <Route path="*" element={<NotFound404 />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
